export const Permissions = {
  Device_View: "Device_View",
  Device_Create: "Device_Create",
  Device_Update: "Device_Update",
  Device_Delete: "Device_Delete",

  ParserConfig_View: "ParserConfig_View",
  ParserConfig_Create: "ParserConfig_Create",
  ParserConfig_Update: "ParserConfig_Update",
  ParserConfig_Delete: "ParserConfig_Delete",

  User_View: "User_View",
  User_Create: "User_Create",
  User_Update: "User_Update",
  User_Delete: "User_Delete",

  Role_View: "Role_View",
  Role_Create: "Role_Create",
  Role_Update: "Role_Update",
  Role_Delete: "Role_Delete",

  Dashboard_View: "Dashboard_View",
  Dashboard_Update: "Dashboard_Update",
  Dashboard_Delete: "Dashboard_Delete",
  Simulate_View: "Simulate_View",

  Company_View: "Company_View",
  Company_Create: "Company_Create",
  Company_Update: "Company_Update",
  Company_Delete: "Company_Delete",

  Department_View: "Department_View",
  Department_Create: "Department_Create",
  Department_Update: "Department_Update",
  Department_Delete: "Department_Delete",

  DeviceGroup_View: "DeviceGroup_View",
  DeviceGroup_Create: "DeviceGroup_Create",
  DeviceGroup_Update: "DeviceGroup_Update",
  DeviceGroup_Delete: "DeviceGroup_Delete",
} as const;

export const Modules = {
  IOT_CORE: "1",
} as const;
